<template>
  <div class="collection-view">
    <div class="tabs-mask">
      <div
        v-for="(item, index) in tabs"
        :key="index"
        class="tab-item"
        :class="{ 'checked-tab': index === checkedTabIndex }"
        @click="checkTab(item, index)"
      >
        {{ langTransfer(item.text) }}
      </div>
    </div>
    <bscroll-view>
      <div class="main-content">
        <div class="list-wrap">
          <div class="result-list">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="article-item"
              @click="pushRouter(item)"
            >
              <!-- @click="detailDispatcher('magazineArticle',item)" -->
              <h6>
                {{ langTransfer(item.title) }}
              </h6>
              <div class="more-info">
                <p>
                  {{ langTransfer(item.author_name) }}
                </p>
                <p>
                  {{ langTransfer(item.action_time) }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="action-warning-wrap">
          <button
            v-show="list.length > 0 && !getAll"
            class="common-read-more lr-img-scale"
            @click="loadMore"
          >
            {{ langTransfer("加载更多") }}
          </button>
          <div v-show="list.length > 0 && getAll" class="has-no-more">
            {{ langTransfer("- 没有更多了 -") }}
          </div>
        </div>
      </div>
    </bscroll-view>
  </div>
</template>

<script>
import BscrollView from "@/components/bscrollView";
import { collectList } from "@/api/hb";

export default {
  name: "Mark",
  components: {
    BscrollView,
  },
  data() {
    return {
      theType: 6,
      checkedTabIndex: 0,
      tabs: [
        {
          text: "期刊",
          type: 6,
        },
        {
          text: "图书",
          type: 9,
        },
        {
          text: "知识库",
          type: 99,
        },
        {
          text: "知识书",
          type: 13,
        },
        {
          text: "汇编书文章",
          type: 17,
        },
      ],
      list: [],
      getAll: false,
      endScreen: false,
    };
  },
  computed: {
    user_unique_code() {
      return this.$store.state.user_unique_code;
    },
    webInfo() {
      return this.$store.state.webInfo;
    },
  },
  watch: {
    webInfo(newVal) {
      if (newVal.service_code) {
        this.getCollectionList();
      }
    },
  },
  created() {},
  methods: {
    pushRouter(item) {
      if (this.theType === 6) {
        this.detailDispatcher("magazineArticle", item);
      } else if (this.theType === 9) {
        this.detailDispatcher("book", item, 'mark');
      } else if (this.theType === 99) {
        const { href } = this.$router.resolve({
          name: "knowledgeLibArticle",
          params: {
            id: item.unique_code,
            secParentId: item.id,
          },
        });
        window.open(href, "_blank");
      } else if (this.theType === 13) {
        this.detailDispatcher("knowledgeBook",item,'mark')
      } else {
        console.log(item)
        this.detailDispatcher('assemblyBook', item , 'mark')
      }
    },
    konwledgebookClickHandler(item) {
      const { href } = this.$router.resolve({
        path: "/occupationBookDetail",
        query: {
          id: item.id,
        },
      });
      window.open(href, "_blank");
    },
    checkTab(item, index) {
      if (this.checkedTabIndex === index) {
        return;
      }
      this.theType = item.type;
      this.checkedTabIndex = index;
      this.getAll = false;
      this.list = [];
      this.getCollectionList();
    },
    loadMore() {
      const newPage = Math.ceil(this.list.length / 10) + 1;
      this.getCollectionList(newPage);
    },
    async getCollectionList(page = 1) {
      try {
        const { tabs, checkedTabIndex } = this;
        const { type } = tabs[checkedTabIndex];
        const data = await collectList({
          type,
          service_code: this.webInfo.service_code,
          page,
          pageSize: 10,
          user_unique_code: this.user_unique_code,
        });
        if (page !== 1) {
          this.list = this.list.concat(data);
          return;
        }
        if (data.length < 10) {
          this.getAll = true;
        }
        this.list = data;
      } catch (err) {
        if (err.code === "-1") {
          this.getAll = true;
        }
        console.log(err);
      }
    },
    formatArticleList(arr) {
      arr.forEach((e) => {
        const typeNum = Number(e.type);
        switch (typeNum) {
          case 6:
            e._bottomInfo = `期刊名称: ${e.author_name} ${
              e.year
            }年${`0${e.issue}`.substr(-2)}期`;
            break;
          case 9:
            e._bottomInfo = `图书名称:  ${e.author_name} 收藏时间：${e.action_time}`;
            break;
          case 1:
            e._bottomInfo = `知识库名称:  ${e.author_name} 收藏时间：${e.action_time}`;
            break;
          default:
            break;
        }
      });
      return arr;
    },
    itemClickHandler(item) {
      console.log(item);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const { service_code } = vm.webInfo;
      if (service_code) {
        vm.getCollectionList();
      }
    });
  },
};
</script>

<style scoped lang="less">
.collection-view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.tabs-mask {
  width: 100%;
  box-sizing: border-box;
  padding: 30px 48px 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.tab-item {
  padding: 5px 10px;
  font-size: 15px;
  font-family: AlibabaPuHuiTiM;
  color: #909399;
  line-height: 24px;
  margin-right: 30px;
  cursor: pointer;
  user-select: none;

  &:last-child {
    margin-right: 0;
  }
}

.checked-tab {
  color: #303133;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
}

.main-content {
  width: 100%;
}

.action-warning-wrap {
  width: 640px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-left: 48px;
  margin-bottom: 40px;

  .has-no-more {
    font-size: 14px;
    font-family: AlibabaPuHuiTiM;
    color: rgb(170, 169, 169);
    line-height: 40px;
    user-select: none;
  }
}

.list-wrap {
  width: 100%;
  padding-bottom: 20px;
}

.result-list {
  width: 100%;
  box-sizing: border-box;
  padding: 0 48px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}

.article-item {
  width: 640px;
  height: 72px;
  box-shadow: 0px 1px 0px 0px #e6e6e6;
  cursor: pointer;

  h6 {
    width: 100%;
    font-size: 18px;
    font-family: AlibabaPuHuiTiM;
    color: #606266;
    line-height: 24px;
    margin: 10px 0 6px;
    font-weight: normal;
  }

  .more-info {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    p {
      font-size: 13px;
      font-family: AlibabaPuHuiTiR;
      color: #909399;
      line-height: 20px;
    }
  }
}
</style>
